import { Stack } from "@chakra-ui/layout";
import { Modal, useTranslation, Text, Input, Button, Flex, useToast } from "@familyzone/component-library";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { CreateCohort, createCohort } from "../../../utils/api/Cohorts";
import { RouterContext } from "../../../utils/RouterContext";

const CohortAddModal = (_: object, context: RouterContext): JSX.Element => {
  const [cohortName, setCohortName] = React.useState("");
  const [cohortDescription, setCohortDescription] = React.useState("");
  const [open, setOpen] = React.useState(false);

  const { t } = useTranslation();
  const { errorToast } = useToast();

  const handleAdd = () => {
    if (cohortName.trim() === "") return;
    const cohort: CreateCohort = {
      name: cohortName,
      description: cohortDescription,
    };
    void createCohort(cohort)
      .then((cohortId) => {
        context.router.push("/config/device/userdb/cohorts/" + cohortId);
      })
      .catch((responseError) => {
        errorToast({ title: "Error", description: "Failed to create cohort: " + String(responseError) });
      });
  };

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        const input = document.querySelector('input[aria-label="cohort name"]');
        if (input) {
          (input as HTMLInputElement).focus();
        }
      }, 100);
    }
  }, [open]);

  return (
    <>
      <Button variant="primary" onClick={() => setOpen(true)}>
        Add Cohort
      </Button>
      <Modal
        headerText={t("Add Cohort")}
        size="md"
        isOpen={open}
        onClose={() => setOpen(false)}
        contentProps={{ style: { overflow: "visible" } }}
      >
        <Stack spacing="sp12" width="100%" my="sp12">
          <Text>Cohort Name</Text>
          <Input
            aria-label="cohort name"
            name="cohort name"
            data-testid="cohortName-input"
            onChange={(e) => setCohortName(e.target.value)}
          ></Input>
        </Stack>
        <Stack spacing="sp12" width="100%" my="sp12">
          <Text>Cohort description</Text>
          <Input
            aria-label="cohort description"
            name="cohort description"
            data-testid="cohortDescription-input"
            onChange={(e) => setCohortDescription(e.target.value)}
          ></Input>
        </Stack>
        <Flex>
          <Button
            data-testid="addButton"
            disabled={!cohortName || cohortName.trim() === ""}
            maxWidth="100%"
            mt="sp12"
            variant="primary"
            onClick={handleAdd}
          >
            Add
          </Button>
        </Flex>
      </Modal>
    </>
  );
};

export default CohortAddModal;

CohortAddModal.contextTypes = {
  router: PropTypes.object.isRequired,
};
